import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Состояние ленты только в памяти (без localStorage). После закрытия миниаппа список и
 * «уже показанные» id для параметра seen сбрасываются — карточки без лайка/дизлайка снова в пуле.
 */
const FeedContext = createContext(null);

export function FeedProvider({ children }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [nextOffset, setNextOffset] = useState(null);

  /** Если пользователь зашёл на товар из ленты и там поставил лайк — при возврате в ленту перейти к следующей карточке */
  const [itemLikedFromProductPage, setItemLikedFromProductPage] = useState(null);

  const value = {
    items,
    setItems,
    loading,
    setLoading,
    error,
    setError,
    currentIndex,
    setCurrentIndex,
    currentPhotoIndex,
    setCurrentPhotoIndex,
    hasMore,
    setHasMore,
    nextOffset,
    setNextOffset,
    itemLikedFromProductPage,
    setItemLikedFromProductPage,
  };

  return (
    <FeedContext.Provider value={value}>
      {children}
    </FeedContext.Provider>
  );
}

export function useFeed() {
  const ctx = useContext(FeedContext);
  if (!ctx) {
    throw new Error('useFeed must be used within FeedProvider');
  }
  return ctx;
}
